import SelectorVideosContainer from 'components/SelectorVideos/SelectorVideosContainer'

export default {
  Container: SelectorVideosContainer,
}
